<template>
  <v-container class="grey lighten-5" fluid style="margin: 0px; padding: 0px;">
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <div class="mainmap" v-if="main_layer">
      <Map2 id="h_m1" type="big" selector="true"
        start="-18667756.795919 14993194.261114" end="19880965.308861 -10057889.929877"
         :main_layer="main_layer"/>
    </div>

  </v-container>
</template>

<script>

import Map2 from '@/components/Map2'
import VectorImageLayer from 'ol/layer/VectorImage'

export default {
  name: 'Home',
  components: {Map2},
  data () {
    let main_layer = null
    let overlay = false
    return {
      main_layer, overlay
    }
  },
   watch: {
       '$store.getters.show_overlay': function() {
          this.overlay = this.$store.getters.show_overlay
      },      
    '$route' () {
    },
  },  
  mounted () {
    this.main_layer = new VectorImageLayer({
      name: 'polygon',
      imageRatio: 2,
    })
    //console.log('FINE MOUNT HOME');
  }      
}
</script>

<style>
  .mainmap
    {
    height: 75vh;
    }

</style>